import { IconWrapper } from '../runtime';
export default IconWrapper('wps_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#1D70F5"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#0059E8"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#3C87FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.3418 3H4.87727L5.88797 7.62035L7.21237 3.5H8.78795L10.1123 7.62035L11.123 3H12.6585L10.9085 11H9.62308L8.00016 5.95091L6.37723 11H5.0918L3.3418 3Z",
      "fill": "white"
    }
  })]);
});